import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

const NavbarOutlet = () => {
  return (
    <div>
      <Navbar />
      <Outlet />
    </div>
  );
};

export default NavbarOutlet;
